export default "__VITE_ASSET__ca69e9be__"